import React from 'react';
import { LinkStoryblok } from '../../../_shared/interfaces/storyblok';
import { StoryblokCommon } from '../../../lib/storyblok/storyblok';
import HsLink from './hs-link';

import * as HsLinkStylesHs from './hs-link.hs.module.scss';
import * as HsLinkStylesDr from './hs-link.dr.module.scss';

import * as StoryblokLinkStyles from './storyblok-link.module.scss';
import { getMultilinkURL } from '../../../lib/helpers/helpers';

const StoryblokLink = ({ blok, storyblokCommon }: { blok: LinkStoryblok; storyblokCommon: StoryblokCommon }) => {
    const HsLinkStyles = storyblokCommon.configuration.content.theme === 'hs' ? HsLinkStylesHs : HsLinkStylesDr;
    return (
        <div className={StoryblokLinkStyles.storyblokLink}>
            {blok.link.linktype === 'story' ? (
                <HsLink to={getMultilinkURL(blok.link)} storyblokCommon={storyblokCommon}>
                    {blok.text}
                </HsLink>
            ) : (
                <a
                    download={true}
                    className={[HsLinkStyles.hsLink, HsLinkStyles.standard].join(' ')}
                    href={getMultilinkURL(blok.link)}
                    target="_blank"
                >
                    {blok.text}
                </a>
            )}
        </div>
    );
};

export default StoryblokLink;
